exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media print {\n  .page-break {\n    page-break-after: auto;\n  }\n  .print-list {\n    page-break-inside: avoid;\n  }\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/shared/print/footer/print-footer.component.styl
// module id = ../../../../../src/app/shared/print/footer/print-footer.component.styl
// module chunks = main